var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "612px",
    height: "612px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.688,
    y: 133.875,
    width: 133.875,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.688,
    y: 76.5,
    width: 133.875,
    height: 19.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.938,0H162.562c-21.038,0-38.25,17.212-38.25,38.25v439.875c0,21.037,17.212,38.25,38.25,38.25h153V612l47.812-47.812 L411.188,612v-95.625h38.25c21.037,0,38.25-17.213,38.25-38.25v-344.25L372.938,0z M372.938,28.688l89.888,105.188h-70.763 c-9.562,0-19.125-9.562-19.125-19.125V28.688z M392.062,566.1l-28.688-28.688L334.688,566.1v-74.587 c9.562,3.825,19.125,5.737,28.688,5.737s19.125-1.912,28.688-5.737V566.1z M363.375,478.125 c-26.775,0-47.812-21.037-47.812-47.812S336.6,382.5,363.375,382.5s47.812,21.037,47.812,47.812S390.15,478.125,363.375,478.125z  M468.562,478.125c0,9.562-7.65,19.125-19.125,19.125h-38.25v-21.037c11.475-11.476,19.125-28.688,19.125-45.9 c0-36.338-30.6-66.938-66.938-66.938s-66.938,30.6-66.938,66.938c0,19.125,7.65,34.425,19.125,45.9v21.037h-153 c-9.562,0-19.125-7.65-19.125-19.125V38.25c0-9.562,7.65-19.125,19.125-19.125h191.25v95.625c0,21.038,17.213,38.25,38.25,38.25 h76.5V478.125z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.688,
    y: 191.25,
    width: 248.625,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.688,
    y: 306,
    width: 248.625,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.688,
    y: 248.625,
    width: 248.625,
    height: 19.125
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparent);
export default __webpack_public_path__ + "static/media/transparent.d0697c6127b992b1a813ce97b35cf99b.svg";
export { ForwardRef as ReactComponent };